import { render, staticRenderFns } from "./MailingListView.vue?vue&type=template&id=deca0a86"
import script from "./MailingListView.vue?vue&type=script&lang=js"
export * from "./MailingListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports